import { Box, Grid, ListItemText, Typography, useTheme } from "@mui/material";
import CenteredColumnGrid from "components/styled/CenteredColumnGrid";
import MainContainer from "components/styled/MainContainer";
import useTruncateString from "hooks/useTruncateString";
import React, { useContext, useEffect } from "react";

import Header from "components/Header/Header";
import ScoreTypesList from "components/lists/ScoreTypesList/ScoreTypesList";
import PageArrows from "components/PageArrows/PageArrows";
import ProjectListButton from "components/styled/ProjectListButton";
import ShortenedText from "components/styled/ShortenedText";
import { PAGES } from "utils/constants";
import { PageContext } from "utils/PageContext";
import { UserContext } from "utils/UserContext";

function ScoreType() {
  useEffect(() => {
    window.scrollTo(0, 0);
  });

  const handleTruncatedString = useTruncateString();

  const { selectedScoreType, selectedAlbum, setAlbums, setSearchQuery } =
    useContext(UserContext);

  const mainTheme = useTheme();

  const { setPage } = useContext(PageContext);

  const isPageComplete = selectedScoreType.length > 0;

  const handlePrevPage = () => {
    if (window.sessionStorage !== undefined) {
      const input = window.sessionStorage.getItem("SearchQuery");
      setSearchQuery(() => {
        if (input !== null) {
          return JSON.parse(input);
        }

        return null;
      });

      const data = window.sessionStorage.getItem("AlbumData");
      setAlbums(() => {
        if (data !== null) {
          return JSON.parse(data);
        }

        return null;
      });
    }
    setPage(PAGES.SEARCH);
  };

  const handleNextPage = () => {
    if (isPageComplete) {
      setPage(PAGES.SORT);
    }
  };

  return (
    <>
      <Header />

      <CenteredColumnGrid
        container
        sx={{
          paddingTop: "calc(2rem + 100px)",
        }}
      >
        <Grid item>
          <Box
            component="section"
            sx={{
              display: "flex",
              flexDirection: "column",
              margin: "0 20px",
              textAlign: "center",
            }}
          >
            <Grid container alignItems="center" direction="column" spacing={2}>
              <Grid item>
                <ProjectListButton
                  sx={{
                    bgcolor: mainTheme.palette.darkBluePrimary.main,
                    cursor: "auto",
                    minWidth: "17rem",
                  }}
                >
                  <img
                    src={selectedAlbum.img}
                    alt=""
                    style={{
                      width: "6.5rem",
                      height: "6.5rem",
                    }}
                  />
                  <ListItemText
                    sx={{
                      margin: "0.5rem",
                    }}
                    primary={handleTruncatedString({
                      customText: selectedAlbum.name,
                      customVariant: "h6",
                      customComponent: "span",
                      customSx: {
                        fontWeight: 600,
                        display: "block",
                        color: mainTheme.palette.whitePrimary.main,
                      },
                      maxCharacters: {
                        sm: 13,
                        smToMd: 37,
                        aboveMd: 63,
                      },
                    })}
                    secondary={
                      <ShortenedText
                        sx={{
                          display: "inline",
                          WebkitLineClamp: 1,
                        }}
                        component="span"
                        variant="body1"
                        color={mainTheme.palette.whitePrimary.main}
                      >
                        {selectedAlbum.mainArtist}
                      </ShortenedText>
                    }
                  />
                </ProjectListButton>
              </Grid>

              <Grid item>
                <Typography
                  component="h1"
                  variant="h6"
                  sx={{
                    fontWeight: 800,
                    padding: "0 1rem",
                  }}
                >
                  Pick a score type for this project.
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </CenteredColumnGrid>

      <MainContainer component="main">
        <CenteredColumnGrid container>
          <Grid item sm={8}>
            <ScoreTypesList />
          </Grid>
        </CenteredColumnGrid>
      </MainContainer>

      <PageArrows
        handlePrevPage={handlePrevPage}
        handleNextPage={handleNextPage}
        isPageComplete={isPageComplete}
      />
    </>
  );
}

export default ScoreType;
